/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Judges_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Judges Guide" |
*
* @param {Help_Judges_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_judges_guide_title = /** @type {((inputs?: Help_Judges_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Judges_Guide_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de l'arbitre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía del juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Guia do Juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida del Giudice")
	return /** @type {LocalizedString} */ ("Judges Guide")
});